import React from "react";

const Email = ({ title, ...props }) => (
  <svg viewBox="0 0 390 390" {...props}>
    {title ? <title>{title}</title> : null}
    <path d="M358 60.8H31.9C14.3 60.8 0 75.2 0 92.7v204.6c0 17.5 14.3 31.9 31.9 31.9h326.3c17.5 0 31.9-14.3 31.9-31.9V92.7c-.2-17.5-14.5-31.9-32.1-31.9zm11.9 215.5l-100.9-75c34.4-29.2 77.2-66.1 100.9-86.6v161.6zM31.9 80.8h326.3c5.2 0 9.6 3.4 11.1 8.1-60.3 52.1-154.5 133-162.9 138.2-6.8 4.3-17 4.3-23.6.1-7.6-5-99.7-83.8-162.3-137.7 1.4-5 5.9-8.7 11.4-8.7zM20 115.4c24.7 21.2 66.1 56.8 99.6 85.3l-99.6 76V115.4zm338 193.7H31.9c-5.1 0-9.4-3.2-11-7.7L135.4 214c19.2 16.3 33.6 28.2 36.7 30.1 6.5 4.2 14.4 6.2 22.3 6.2s15.9-2 22.5-6.2c3.6-2.2 17.7-13.8 36.4-29.5l115.9 86.3c-1.5 4.7-5.9 8.2-11.2 8.2z" />
  </svg>
);

export default Email;
